import { ProductDropdownReceivers } from "./receivers";

export class ProductDropdownTubes extends ProductDropdownReceivers {
    constructor(elem, _refs) {
        super(elem, _refs);
    }
}